// src/components/forms/SymptomsSection.jsx
import React from 'react';


const SymptomsSection = ({ symptoms, onSymptomChange, availableSymptoms = [] }) => {
  // Define the desired order by indices from AVAILABLE_SYMPTOMS
  // const leftColumnIndices = [0, 1, 2, 3];  // Shortness, Swelling, Weight gain, Fatigue
  // const rightColumnIndices = [4, 5, 6, 7]; // Chest pain, Dizziness, Persistent cough, Trouble sleeping

  // const leftColumn = leftColumnIndices.map(index => AVAILABLE_SYMPTOMS[index]);
  // const rightColumn = rightColumnIndices.map(index => AVAILABLE_SYMPTOMS[index]);
  const midpoint = Math.ceil(availableSymptoms.length / 2);
  const leftColumn = availableSymptoms.slice(0, midpoint);
  const rightColumn = availableSymptoms.slice(midpoint);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Symptoms to Ask About</h3>
      <p className="text-sm text-gray-600">
        Select which symptoms to ask the patient about during calls. All symptoms must be included (checked or unchecked).
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-3">
          {leftColumn.map((symptom) => (
            <div key={symptom.code} className="flex items-center">
              <input
                id={`symptom-${symptom.code}`}
                type="checkbox"
                checked={symptoms[symptom.code] || false}
                onChange={(e) => onSymptomChange(symptom.code, e.target.checked)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label 
                htmlFor={`symptom-${symptom.code}`}
                className="ml-2 text-sm font-medium text-gray-700"
              >
                {symptom.name}
              </label>
            </div>
          ))}
        </div>

        {/* Right Column */}
        <div className="space-y-3">
          {rightColumn.map((symptom) => (
            <div key={symptom.code} className="flex items-center">
              <input
                id={`symptom-${symptom.code}`}
                type="checkbox"
                checked={symptoms[symptom.code] || false}
                onChange={(e) => onSymptomChange(symptom.code, e.target.checked)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label 
                htmlFor={`symptom-${symptom.code}`}
                className="ml-2 text-sm font-medium text-gray-700"
              >
                {symptom.name}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SymptomsSection;